export default "__VITE_ASSET__8i9aGRVh__"